import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logs-digicod',
  templateUrl: './logs-digicod.component.html',
  styleUrls: ['./logs-digicod.component.scss']
})
export class LogsDigicodComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
